import { useEffect, useState } from 'react';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { MessageTypes } from 'store/declarations/enums/common/declaration-types';
import { getProductTemplateClient } from 'store/products-templates/getProductTemplateClient';

interface Props {
    country?: DeclarationCountry;
    internalType?: DeclarationInternalType;
    messageType?: MessageTypes;
}

const useProductTemplateTags = ({ country, internalType, messageType }: Props) => {
    const [tags, setTags] = useState<string[]>([]);

    useEffect(() => {
        setTags([]);
        if (!(country && internalType && messageType)) return;

        // The identity may change before the response arrives, in which case it is no longer wanted.
        let isCurrent = true;

        getProductTemplateClient(country, internalType, messageType)
            .listTags()
            .then((response) => {
                if (isCurrent) setTags(response);
            })
            .catch(() => {
                if (isCurrent) setTags([]);
            });

        return () => {
            isCurrent = false;
        };
    }, [country, internalType, messageType]);

    return tags;
};

export default useProductTemplateTags;
